export default __webpack_public_path__ + "static/go@1200-8c748a6052057a13270256b70b05181b.svg";